<template>
  <select
    :value="modelValue"
    @change="handleChange"
    :disabled="disabled || isLoading"
    class="block w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm disabled:opacity-50"
  >
    <option v-for="role in availableRoles" :key="role.value" :value="role.value">
      {{ role.label }}
    </option>
  </select>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import type { OrganizationRole } from '../types';

  interface Props {
    modelValue: OrganizationRole;
    disabled?: boolean;
    isLoading?: boolean;
    excludeOwner?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    excludeOwner: true,
  });

  const emit = defineEmits<{
    (e: 'update:modelValue', value: OrganizationRole): void;
    (e: 'change', value: OrganizationRole): void;
  }>();

  const availableRoles = computed(() => {
    const roles = [
      { value: 'owner', label: 'Owner' },
      { value: 'admin', label: 'Admin' },
      { value: 'member', label: 'Member' },
    ];

    if (props.excludeOwner) {
      return roles.filter(r => r.value !== 'owner');
    }

    return roles;
  });

  const handleChange = (event: Event) => {
    const value = (event.target as HTMLSelectElement).value as OrganizationRole;
    emit('update:modelValue', value);
    emit('change', value);
  };
</script>
